import React from "react";
import "./style.css";

export const CourseTeacherBio = ({name, subtitle, description, image}) => {
  return (
    <div className="course_teacher_bio">

      <div className="course_teacher_bio_image_container">
        <img className="course_teacher_bio_image" src={image} loading="lazy" alt={name} />
      </div>

      <div className="course_teacher_bio_info_container">
        <div className="course_teacher_bio_name">
          {name}
        </div>
        <div className="course_teacher_bio_subtitle">
          {subtitle}
        </div>
        <div className="course_teacher_bio_description" dangerouslySetInnerHTML={{__html: description}}>
        
        </div>
      </div>

    </div>
  );
};
